import { useMutation, useQueryClient } from "@tanstack/react-query"
import { call } from "../../library/networking/API"
import {
  mutateInfinite,
  mutateRecord,
  mutationTypes,
} from "../../library/utils/reactQuery"
import { POSTS } from "../../library/store/actions/types/postsTypes"

export const useLikesMutations = ({ key, mutationType }) => {
  const queryClient = useQueryClient()

  const createLike = useMutation({
    mutationFn: async ({
      data: { post_id, comment_id, product_review_id },
    }) => {
      await call(POSTS.LIKES.CREATE, {
        post_id,
        comment_id,
        product_review_id,
      })
    },
    onSuccess: async (data, variables) => {
      const { updater } = variables
      if (mutationType === mutationTypes.record) {
        await mutateRecord({
          queryClient,
          key,
          recordUpdater: updater,
        })
      }

      if (mutationType === mutationTypes.infinite) {
        await mutateInfinite({
          queryClient,
          key,
          itemUpdater: updater,
        })
      }
    },
  })

  const deleteLike = useMutation({
    mutationFn: async ({
      data: { post_id, comment_id, product_review_id },
    }) => {
      await call(POSTS.LIKES.DELETE, {
        post_id,
        comment_id,
        product_review_id,
      })
    },
    onSuccess: async (data, variables) => {
      const { updater } = variables
      if (mutationType === mutationTypes.record) {
        await mutateRecord({
          queryClient,
          key,
          recordUpdater: updater,
        })
      }

      if (mutationType === mutationTypes.infinite) {
        await mutateInfinite({
          queryClient,
          key,
          itemUpdater: updater,
        })
      }
    },
  })

  return {
    likes: {
      create: createLike,
      delete: deleteLike,
    },
  }
}
